import type { SVGProps } from 'react'
const SvgSyMinus = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M3.9 10.8h16.2v2.3H3.9z" />
	</svg>
)
export default SvgSyMinus
